export default "__VITE_ASSET__FEW2N2zS__"